import { createContext } from "react";

export const ludoContext = createContext(0)
export const appContext = createContext(0)